import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import fr from 'facet-rest';
import Button from 'Components/UI/Button';
import AttachFileIcon from '@material-ui/icons/AttachFile';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingBottom: theme.spacing(2),
  },
  attachmentsContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  header: {
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: theme.spacing(2),
  },
  button: {},
});

const AttachmentsContent = ({
  className,
  classes,
  resource,
}) => {
  const onAttachmentClicked = (e, documentResource) => {
    if (documentResource.relationship(fr.relationships.download.name)) {
      e.preventDefault();
      e.stopPropagation();
      const downloadLink = documentResource.relationship(fr.relationships.download.name).link('related').url();
      window.open(downloadLink, '_blank', 'noreferrer noopener nofollow');
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography variant={'h3'} color={'primary'} className={classes.header}>
        {'Attachments'}
      </Typography>
      <div className={classes.attachmentsContainer}>
        {resource.attr('attachedDocuments').resources().list().map((attachedDocument) => {
          return (
            <Button
              className={classes.button}
              disableElevation
              onClick={(e) => onAttachmentClicked(e, attachedDocument)}
            >
              <AttachFileIcon fontSize={'small'} />
              <Typography
                variant={'h5'}
                color={'primaryGray'}
              >
                {` ${attachedDocument.attr('name')}`}
              </Typography>
            </Button>
          );
        })}
      </div>
    </Box>
  );
};

AttachmentsContent.defaultProps = {
  className: '',
};

AttachmentsContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AttachmentsContent);
